import { Box } from '@mui/material';
import { Property } from 'csstype';
import React from 'react';

type HelixImageBreakpoints = {
  xs?: string;
  sm?: string;
  md?: string;
  lg?: string;
  xl?: string;
};

type HelixImageProps = {
  height?: Property.Height;
  display?: Property.Display;
  imageBreakpoints: HelixImageBreakpoints;
  altText: string;
};

const mockHelixImageProps: HelixImageProps = {
  altText: 'Logo',
  display: 'flex',
  height: '64px',
  imageBreakpoints: {
    lg: '/images/LG.png',
    md: '/images/MD.png',
    sm: '/images/SM.png',
    xl: '/images/XL.png',
    xs: '/images/XS.png',
  },
};

const HelixImage: React.FC<HelixImageProps> = ({ imageBreakpoints, display, height, altText }) => {
  const breakpoints: Array<keyof HelixImageBreakpoints> = ['xs', 'sm', 'md', 'lg', 'xl'];
  const content = breakpoints.reduce<typeof imageBreakpoints>((previousValue, currentValue) => {
    const breakpointTarget = imageBreakpoints[currentValue];
    if (breakpointTarget) {
      previousValue[currentValue] = `url(${breakpointTarget})`;
    }
    return previousValue;
  }, {});

  return (
    <Box
      component="img"
      sx={{
        content,
        display,
        height,
      }}
      alt={altText}
    />
  );
};

export { HelixImage as default, HelixImage, mockHelixImageProps };
export type { HelixImageProps };
